var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',{staticClass:"container"},[_c('el-header',[_c('header-module')],1),_c('el-container',{staticClass:"container_content"},[_c('el-aside',{attrs:{"width":"218px"}},[_c('aside-module')],1),_c('el-main',[_c('main-module')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }